import { all } from 'redux-saga/effects';

function* rootSaga() {
  return yield all([]);
}

export default rootSaga;
